import { PayModifierCategory } from '@amzn/atoz-shiftapp-types';
export var isSurgePay = function (payCategories) {
    if (!payCategories) {
        return false;
    }
    return payCategories.some(function (payCategory) {
        return payCategory.category === PayModifierCategory.HighDemandPremium;
    });
};
